import { render, staticRenderFns } from "./LogRoundDeleteSetNumber.vue?vue&type=template&id=897925e8&"
import script from "./LogRoundDeleteSetNumber.vue?vue&type=script&lang=js&"
export * from "./LogRoundDeleteSetNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports